(function () {
  UserActivityController.$inject = ["$log", "$scope", "Users"];
  angular.module('pims').directive('userActivity', userActivity);
  /* @ngInject */

  function UserActivityController($log, $scope, Users) {
    const self = this;
    Object.assign(self, {
      activities: [],
      pagination: {
        offset: 0,
        limit: 20
      }
    });

    self.load = function () {
      Users.getActivity(self.user.id, self.pagination).then(results => {
        const data = results.data;
        self.pagination = data.pagination;
        self.pagination.offset = self.pagination.offset + self.pagination.limit;

        _createTimeline(data.data);
      }).catch(err => {
        $log.error(err);
      });
    };
    /* Private Methods */


    function _createTimeline(activities) {
      activities.forEach(activity => {
        switch (activity.action_id) {
          case 11:
          case 15:
          case 19:
          case 33:
          case 34:
            activity.icon = 'ion-eye';
            activity.background = 'success';
            break;

          case 4:
          case 10:
          case 9:
            activity.icon = 'ion-person';
            activity.background = 'primary';
            break;

          case 13:
          case 17:
          case 21:
            activity.icon = 'ion-checkmark';
            activity.background = 'success';
            break;

          case 1:
          case 35:
            activity.icon = 'ion-log-in';
            activity.background = 'success';
            break;

          case 2:
            activity.icon = 'ion-log-in';
            activity.background = 'alert';
            break;

          case 12:
          case 16:
            activity.icon = 'ion-bag';
            activity.background = 'primary';
            break;

          case 5:
          case 22:
            activity.icon = 'ion-key';
            activity.background = 'success';
            break;

          case 8:
            activity.icon = 'ion-gear-a';
            activity.background = 'warning';
            break;

          case 6:
          case 23:
            activity.icon = 'ion-key';
            activity.background = 'alert';
            break;

          case 26:
            activity.icon = 'ion-chatbubbles';
            activity.background = 'info';
            break;

          case 29:
            activity.icon = 'ion-erlenmeyer-flask';
            activity.background = 'alert';
            break;
        }

        self.activities.push(activity);
      });
      $log.log('Activities: ', self.activities);
    }

    $scope.$on('tab-clicked', (event, tab) => {
      if (tab === 'activity' && !self.loaded) {
        self.load();
      }
    });
  }
  /* @ngInject */


  function userActivity() {
    return {
      scope: {
        user: '='
      },
      templateUrl: 'app/views/users/detail/tabs/activity/user-activity.tab.html',
      controller: UserActivityController,
      controllerAs: 'activity',
      bindToController: true
    };
  }
})();